export default function phoneFilter(phone_number){
    if(phone_number.length == 13 && phone_number.substr(0,4) == '+380'){
        return '(' + phone_number.substr(3,3) + ') ' + phone_number.substr(6,3) + '-' + phone_number.substr(9,2) + '-' + phone_number.substr(11,2)
    }else{
        return phone_number
    }
}